import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
const resource = 'mp_business_commission_jobs'
import {
  RecruitingStatus,
  MpBusinessCommissionJob,
} from 'types/mp_business_commission_job'

export const requests = {
  update: async (params: {
    id: number
    recruiting_status?: RecruitingStatus
  }) => {
    return await axiosForGigbaseBiz.patch<
      DataResponse<MpBusinessCommissionJob>
    >(mergeURL(resource, params.id.toString()), params)
  },
}
